import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  RouteParamsTypes,
  Modules,
  NonAuthRoutes,
  PermissionModulesEnum,
  PermissionActionsEnum
} from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import PayoutList from '../modules/reconciliation/payout/list';
import ManagerStatementList from '../modules/reconciliation/managerStatement/list';
import ManagerStatementDetail from '../modules/reconciliation/managerStatement/detail';

const Reconciliation: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteParamsTypes.payout} element={<ProtectedRoute component={PayoutList} accessibleTo={[{ [PermissionModulesEnum.Reconciliation]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.managerStatement} element={<ProtectedRoute component={ManagerStatementList} accessibleTo={[{ [PermissionModulesEnum.ManagerStatement]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.managerStatement + RouteParamsTypes.id} element={<ProtectedRoute component={ManagerStatementDetail} accessibleTo={[{ [PermissionModulesEnum.ManagerStatement]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.any} element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />} />
    </Routes>
  );
};

export default Reconciliation;
